import { MoreMenuButton } from '@/components/MoreMenuButton';
import useStore from '@/store/use-store';
import trash2Outline from '@iconify/icons-eva/trash-2-outline';
import { Icon } from '@iconify/react';
import { ListItemIcon, ListItemText, Menu, MenuItem } from '@mui/material';
import PropTypes from 'prop-types';
import { useRef, useState } from 'react';

RequestMoreMenu.propTypes = {
  id: PropTypes.number
};

export default function RequestMoreMenu({ id }) {
  const ref = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  const { removeRequest } = useStore((state) => state);

  const onDeleteClick = () => {
    removeRequest(id);
    setIsOpen(false);
  };

  return (
    <>
      <MoreMenuButton isOpen={isOpen} setIsOpen={setIsOpen} menuId="request-more-menu" ref={ref} />

      <Menu
        id="request-more-menu"
        open={isOpen}
        anchorEl={ref.current}
        onClose={() => setIsOpen(false)}
        PaperProps={{
          sx: { width: 200, maxWidth: '100%' }
        }}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <MenuItem sx={{ color: 'text.secondary' }} onClick={() => onDeleteClick()}>
          <ListItemIcon>
            <Icon icon={trash2Outline} width={24} height={24} />
          </ListItemIcon>
          <ListItemText primary="Delete" primaryTypographyProps={{ variant: 'body2' }} />
        </MenuItem>
      </Menu>
    </>
  );
}
